import secondaryButton from '../../secondary-button/branded-solid/background/default';

const primary = (params) => secondaryButton.primary(params);

export default primary;
